/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromGameRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromGameRequest(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromGameRequestFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
        'Game': json['Game'],
        'Platform': json['Platform'] == null ? undefined : json['Platform'],
        'Standalone': json['Standalone'] == null ? undefined : json['Standalone'],
        'DeviceId': json['DeviceId'] == null ? undefined : json['DeviceId'],
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromGameRequestToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
        'Game': value['Game'],
        'Platform': value['Platform'],
        'Standalone': value['Standalone'],
        'DeviceId': value['DeviceId'],
        'Locale': value['Locale'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromGameRequest.js.map